import { useCallback, useRef, useState } from 'react';
import { hasUnsavedFeaturesInSessionStorage } from '../utils/unsavedFeaturesStorage';

/**
 * Tracks Overview + Features unsaved state for the slideout panel.
 * Extracted from SlideOutPanel/index.tsx (Part 2A modularisation).
 */
export function useSlideoutUnsavedChanges() {
  const overviewHasUnsavedChanges = useRef(false);
  const [overviewResetTrigger, setOverviewResetTrigger] = useState(0);

  const hasUnsavedFeatures = useCallback(
    () => hasUnsavedFeaturesInSessionStorage(),
    []
  );

  const hasUnsavedChanges = useCallback(() => {
    return hasUnsavedFeatures() || overviewHasUnsavedChanges.current;
  }, [hasUnsavedFeatures]);

  return {
    overviewHasUnsavedChanges,
    overviewResetTrigger,
    setOverviewResetTrigger,
    hasUnsavedFeatures,
    hasUnsavedChanges
  };
}
